// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".referenceContainer[data-v-26254251]{padding:.5rem}.references[data-v-26254251]{margin:0;padding:.5rem .5rem .5rem 1.5rem}.references li[data-v-26254251]{padding:.5rem}.references a[data-v-26254251]{text-decoration:none;color:#f26721}.references a[data-v-26254251]:hover{color:#f58851}body[dir=rtl] .references[data-v-26254251]{padding:.5rem 1.6rem .5rem .5rem}", ""]);
// Exports
module.exports = exports;
